import VueSocialSharing from 'vue-social-sharing';

import { closeAllCollapses } from '@root/src/framework/scripts/utils/bootstrap';
import { App } from '~/app';

import { defineAsyncComponent } from 'vue';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Share On Socials Component');

    app.vueApp.component('stockland-share-link-list', defineAsyncComponent(async () => import("./StocklandShareLinkList.vue")));
    app.vueApp.component('stockland-share-on-socials', defineAsyncComponent(async () => import("./StocklandShareOnSocials.vue")));

    // Third party plugin - https://github.com/nicolasbeauvais/vue-social-sharing
    app.vueApp.use(VueSocialSharing);

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            const pageLayoutContainer = document.querySelector<HTMLElement>('.container');
            const shareOnSocialButton = document.querySelectorAll<HTMLElement>('#shareIcons');
			

            if (pageLayoutContainer && shareOnSocialButton) {
                pageLayoutContainer.addEventListener('click', () => closeAllCollapses(shareOnSocialButton));
                listeners.push([pageLayoutContainer, 'click', () => closeAllCollapses(shareOnSocialButton)]);
            }
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Share On Socials component', error);
        });

    return function destroyShareOnSocials() {
        for (const [element, event, listener] of listeners) {
            element.removeEventListener(event, listener);
        }

        app.logger.debug('[DXA] Stockland Share On Socials component destroyed');
    };
};